import { api } from "./../helper/api";

if (
  localStorage.getItem("token") &&
  JSON.parse(atob(localStorage.getItem("token").split(".")[1])).user.sigBanco ==
    undefined
) {
  localStorage.removeItem("token");
  localStorage.removeItem("permisos");
}

const SOCKET_PROCESO = "SOCKET_GESTOR_CARGUE" + (localStorage.getItem("token") ? JSON.parse(atob(localStorage.getItem("token").split(".")[1])).user.sigBanco.nit : null || null);

const SOCKET_GARANTIZADOS = "SOCKET_INFORME_GARANTIZADO" + (localStorage.getItem("token") ? JSON.parse(atob(localStorage.getItem("token").split(".")[1])).user.sigBanco.nit : null || null);

export default {
  state: {
    reload: 1,
    dataInformes: {
      datos: [],
      paginacion: {
        total: 0,
      },
    },
    convenios: [],
    productos: [],
    utilidadesDescargas: [],
    dataSlider: [],

    // dataSlider: [
    //   {
    //     titulo: null,
    //     subtitulo: null,
    //     text: null,
    //     img_src: "/images/home/01 Devoluciones y reintegros.jpg",
    //     boton: false,
    //     texto_boton: null,
    //     href: null,
    //   },
    //   {
    //     titulo: null,
    //     subtitulo: null,
    //     text: null,
    //     img_src: "/images/home/01-banner-carteras-actualizadas.jpg",
    //     boton: false,
    //     texto_boton: null,
    //     href: null,
    //   },
    //   {
    //     titulo: null,
    //     subtitulo: null,
    //     text: null,
    //     img_src: "/images/home/03-banner-certificaciones-contables.jpg",
    //     boton: false,
    //     texto_boton: null,
    //     href: null,
    //   },
    // ],
    Informes: [
      {
        id: "1",
        imagen: "/images/pages/informes/Resumen.svg",
        nombre_permiso: "resumen_cifras",
        visible: false,
        titulo: "Resumen de cifras",
        texto:
          "Resumen consolidado de las operaciones, cifras de movilizados, saldos de cartera y valor de operaciones pagadas.",
        path: "resumen-cifras",
      },
      {
        id: "2",
        imagen: "/images/pages/informes/Base.svg",
        nombre_permiso: "base_garantizados",
        visible: false,
        titulo: "Base operaciones",
        texto:
          "Consulte y/o descargue la información general de cada una de las operaciones que se reportaron efectivamente y se encuentran cubiertas con un producto de FGA Fondo de Garantías.",
        path: "base-garantizado",
      },
      {
        id: "17",
        imagen: "/images/pages/informes/Base.svg",
        nombre_permiso: "base_garantizados2",
        visible: false,
        titulo: "Base operaciones",
        texto:
          "Consulte y/o descargue la información general de cada una de las operaciones que se reportaron efectivamente y se encuentran cubiertas con un producto de FGA Fondo de Garantías.",
        path: "base-garantizado2",
      },
      {
        id: "3",
        imagen: "/images/pages/informes/Consulta.svg",
        nombre_permiso: "consulta_general",
        visible: false,
        titulo: "Consulta general ",
        texto:
          "Información detallada de cada una de las Coberturas (información del crédito, información de la Cobertura, carteras reportadas).",
        path: "consulta-general",
      },
      {
        id: "4",
        imagen: "/images/pages/informes/Garantias.svg",
        nombre_permiso: "garantias_pagados",
        visible: false,
        titulo: "Operaciones pagadas",
        texto:
          "Consulte y/o descargue la información general de cada una de las operaciones que se reclamaron efectivamente y han sido pagadas.",
        path: "garantia-pagada",
      },
      {
        id: "5",
        imagen: "/images/pages/informes/PreFactura.svg",
        nombre_permiso: "prefactura",
        visible: false,
        titulo: "Prefactura",
        texto:
          "Seleccione y descargue la relación detallada de cada uno de los registros que se facturan, es decir, un soporte detallado de la factura.",
        path: "prefactura",
      },
      {
        id: "6",
        imagen: "/images/pages/informes/Memorando.svg",
        nombre_permiso: "memorando",
        visible: false,
        titulo: "Memorando",
        texto:
          "Obtenga un informe detallado, en formato PDF, del pago realizado producto de una reclamación de garantías, del mes en curso.",
        path: "memorando",
      },
      {
        id: "7",
        imagen: "/images/pages/informes/Memorando.svg",
        nombre_permiso: "devoluciones",
        visible: false,
        titulo: "Devoluciones",
        texto:
          "Descargue el informe actualizado, con el que se puede conocer las operaciones que son sujetas de devolución total a FGA Fondo de Garantías del valor reclamado, debido a una inconsistencia por parte del intermediario financiero.",
        path: "devoluciones",
      },
      {
        id: "8",
        imagen: "/images/pages/informes/Memorando.svg",
        nombre_permiso: "reintegros",
        visible: false,
        titulo: "Reintegros",
        texto:
          "Descargue el informe actualizado, con el que se puede conocer los valores a reintegrar a FGA Fondo de Garantías, producto de pagos parciales de los deudores, posterior al pago de la garantía por parte de FGA Fondo de Garantías.",
        path: "reintegros",
      },
      {
        id: "9",
        imagen: "/images/pages/informes/Memorando.svg",
        nombre_permiso: "en_tramite_pago",
        visible: false,
        titulo: "En trámite de pago",
        texto:
          "Visualice el estado en que se encuentra el proceso de reclamación del mes en curso.",
        path: "en-tramite-de-pago",
      },
      {
        id: "10",
        imagen: "/images/pages/informes/Memorando.svg",
        nombre_permiso: "novedades",
        visible: true,
        titulo: "Novedades",
        texto:
          "Detalle de las novedades/casos realizados en determinada fecha.",
        path: "informe-novedades",
      },
      {
        id: "11",
        imagen: "/images/pages/informes/Memorando.svg",
        nombre_permiso: "subsanaciones",
        visible: false,
        titulo: "Subsanaciones",
        texto:
          "Consulte las operaciones en proceso de reclamación a FGA Fondo de Garantías, que presentan inconsistencia y que requieren corrección para su respectivo trámite de pago.",
        path: "subsanaciones",
      },
      {
        id: "12",
        imagen: "/images/pages/informes/Memorando.svg",
        nombre_permiso: "rechazos",
        visible: false,
        titulo: "Rechazos",
        texto:
          "Consulte el historial o las causales de rechazo en el proceso de reclamación que ha tenido una garantía",
        path: "rechazos",
      },
      {
        id: "13",
        imagen: "/images/pages/informes/Memorando.svg",
        nombre_permiso: "estado_carteras_actualizadas",
        visible: false,
        titulo: "Estado de carteras actualizadas",
        texto:
          "Detalle de operaciones que están pendientes de actualización de saldos de cartera, al último corte requerido.",
        path: "estado-carteras-actualizadas",
      },
      {
        id: "14",
        imagen: "/images/pages/informes/Memorando.svg",
        nombre_permiso: "estado_reclamaciones",
        visible: false,
        titulo: "Estado de reclamaciones",
        texto: "Haga seguimiento del estado de un proceso de reclamación.",
        path: "estado-reclamaciones",
      },
      {
        id: "15",
        imagen: "/images/pages/informes/Memorando.svg",
        nombre_permiso: "venta_compra_cartera",
        visible: false,
        titulo: "Venta o compra de cartera",
        texto:
          "Consulte el detalle de operaciones que fueron vendidas o compradas en un periodo de tiempo determinado.",
        path: "venta-compra-cartera",
      },
      {
        id: "16",
        imagen: "/images/pages/informes/Memorando.svg",
        nombre_permiso: "resumen_utilizaciones",
        visible: false,
        titulo: "Resumen de utilizaciones",
        texto:
          "Detalle de las utilizaciones que fueron registradas en un periodo de tiempo determinado",
        path: "resumen-utilizaciones",
      },
      {
        id: "17",
        imagen: "/images/pages/informes/Garantias.svg",
        nombre_permiso: "estado_factura",
        visible: false,
        titulo: "Estado de factura",
        texto:
          "Consulte y/o descargue la información de facturas.",
        path: "estado-facturas",
      },
      {
        id: "18",
        imagen: "/images/pages/informes/Garantias.svg",
        nombre_permiso: "fraude",
        visible: false,
        titulo: "Validación fraude",
        texto:
          "Consulte y valide las operaciones que han sido marcadas como fraude.",
        path: "validacion-fraude",
      },
      {
        id: "19",
        imagen: "/images/pages/informes/Garantias.svg",
        nombre_permiso: "informe_abonos_portal",
        visible: false,
        titulo: "Informe de abonos",
        texto:
          "Consulte los abonos realizados y las retribuciones correspondientes",
        path: "abonos-retribuciones",
      },
      {
        id: "212",
        imagen: "/images/pages/informes/RiesgoOperativo.svg",
        nombre_permiso: "riesgo_operativo",
        visible: false,
        titulo: "Riesgo Operativo",
        texto:
          "Resumen consolidado del disponible correspondiente para el proceso de reclamaciones con riesgo operativo",
        path: "riesgo-operativo",
      },
      {
        id: "220",
        imagen: "/images/pages/informes/observador.svg",
        nombre_permiso: "observador",
        visible: false,
        titulo: "Observador",
        texto:
          "Consulta de información global de los clientes",
        path: "observador",
      },
    ],

    CargaArchivos: [
      {
        id: 1,
        titulo: "Utilizaciones",
        nombre_permiso: "cargue_modificacion_utilizaciones",
        visible: false,
        slug: "utilizaciones",
        texto:
          "Registro de cada uno de los usos asociados a un cupo de crédito.",
        path: "utilizaciones",
        intro:
          "En este espacio podrás cargar los archivos de utilizaciones relacionados con cada convenio",
        recomendacion: `<b>Para que sea un cargue exitoso le recomendamos:</b><br><br>
                <b>1. Nombre del archivo:</b> debe tener el siguiente formato <b>u_nit_convenio_mesaño</b> <br>
                    -	u indica que el archivo es de utilizaciones <br>
                    -	nit de la entidad <br>
                    -	código: código del convenio o modelo al que pertenece la operación<br>
                    -	mesaño mes del año de dos dígitos seguido del año completo de cuatro dígitos <br>
                <b>2. Formato del archivo:</b> <br>
                    -	El archivo solo podrá tener el formato TXT (texto plano) <br>
                    -	Ejemplo: u_nit_convenio_062012.txt <br>
                <b>3. Formato fecha:</b> <br>
                    -	El formato de las fechas debe ser el siguiente (AAAA-MM-DD)`,
      },
      {
        id: 2,
        titulo: "Novaciones",
        nombre_permiso: "cargue_novaciones_plazo",
        visible: false,
        slug: "novaciones-plazo",
        texto:
          "Registro del proceso de novación de una operación previamente registrada y reportada.",
        path: "novaciones",
        intro:
          "En este espacio podrás cargar los archivos de novaciones relacionados con cada convenio",
        recomendacion: `<b>Para que sea un cargue exitoso le recomendamos:</b><br><br>
                <b>1. Nombre del archivo:</b> debe tener el siguiente formato <b>n_nit_convenio_mesaño</b> <br>
                    -	n indica que el archivo es de novaciones <br>
                    -	nit de la entidad <br>
                    -	código: código del convenio o modelo al que pertenece la operación <br>
                    -	mesaño mes del año de dos dígitos seguido del año completo de cuatro dígitos <br>
                <b>2. Formato del archivo:</b> <br>
                    -	El archivo solo podrá tener el formato TXT (texto plano) <br>
                    -	Ejemplo: n_nit_convenio_062012.txt <br>
                <b>3. Formato fecha:</b> <br>
                    -	El formato de las fechas debe ser el siguiente (AAAA-MM-DD)`,
      },
      {
        id: 3,
        titulo: "Renovaciones",
        nombre_permiso: "cargue_renovaciones",
        visible: false,
        slug: "renovaciones",
        texto:
          "Registro del proceso de renovación de una operación de crédito previamente registrada y reportada.",
        path: "renovaciones",
        intro:
          "En este espacio podrás cargar los archivos de renovaciones relacionados con cada convenio",
        recomendacion: `<b>Para que sea un cargue exitoso le recomendamos:</b><br><br>
                <b>1. Nombre del archivo:</b> debe tener el siguiente formato <b>e_nit_convenio_mesaño</b> <br>
                    -	e indica que el archivo es de renovaciones <br>
                    -	nit de la entidad <br>
                    -	código: código del convenio o modelo al que pertenece la operación <br>
                    -	mesaño mes del año de dos dígitos seguido del año completo de cuatro dígitos <br>
                <b>2. Formato del archivo:</b> <br>
                    -	El archivo solo podrá tener el formato TXT (texto plano) <br>
                    -	Ejemplo: e_nit_convenio_062012.txt <br>
                <b>3. Formato fecha:</b> <br>
                    -	El formato de las fechas debe ser el siguiente (AAAA-MM-DD)`,
      },
      {
        id: 4,
        titulo: "Refinanciaciones",
        nombre_permiso: "cargue_refinanciaciones",
        visible: false,
        slug: "refinanciaciones",
        texto:
          "Registro del proceso de refinanciación de una operación de crédito previamente registrada y reportada.",
        path: "refinanciaciones",
        intro:
          "En este espacio podrás cargar los archivos de refinanciaciones relacionados con cada convenio",
        recomendacion: `<b>Para que sea un cargue exitoso le recomendamos:</b><br><br>
                <b>1. Nombre del archivo:</b> debe tener el siguiente formato <b>f_nit_convenio_mesaño</b> <br>
                    -	f indica que el archivo es de refinanciaciones <br>
                    -	nit de la entidad <br>
                    -	código: código del convenio o modelo al que pertenece la operación <br>
                    -	mesaño mes del año de dos dígitos seguido del año completo de cuatro dígitos <br>
                <b>2. Formato del archivo:</b> <br>
                    -	El archivo solo podrá tener el formato TXT (texto plano) <br>
                    -	Ejemplo: f_nit_convenio_062012.txt <br>
                <b>3. Formato fecha:</b> <br>
                    -	El formato de las fechas debe ser el siguiente (AAAA-MM-DD)`,
      },
      {
        id: 5,
        titulo: "Desistimiento Garantias",
        nombre_permiso: "cargue_desistimiento_garantia",
        visible: false,
        slug: "desistimiento-garantia",
        texto:
          "Ingreso de las nuevas operaciones de crédito desembolsadas con productos FGA Fondo de Garantías.",
        path: "desistimiento-garantia",
        intro:
          "Este espacio ha sido diseñado para la carga de desistimiento de las operaciones, relacionados con cada convenio",
        recomendacion: `<b>Para que sea un cargue exitoso le recomendamos:</b><br><br>
                <b>1. Nombre del archivo:</b> debe tener el siguiente formato <b>d_nit_convenio_mesaño</b> <br>
                    -	d indica que el archivo es de desistimiento de las operaciones <br>
                    -	nit de la entidad <br>
                    -	código: código del convenio o modelo al que pertenece la operación<br>
                    -	mesaño mes del año de dos dígitos seguido del año completo de cuatro dígitos <br>
                <b>2. Formato del archivo:</b> <br>
                    -	El archivo solo podrá tener el formato TXT (texto plano) <br>
                    -	Ejemplo: d_nit_convenio_062012.txt <br>
                <b>3. Formato fecha:</b> <br>
                    -	El formato de las fechas debe ser el siguiente (AAAA-MM-DD)`,
      },
      {
        id: 6,
        titulo: "Cartera",
        nombre_permiso: "cargue_cartera",
        visible: false,
        slug: "cartera",
        texto:
          "Proceso de actualización de saldos al cierre de cada mes de las operaciones previamente garantizadas y registradas.",
        path: "cartera",
        intro:
          "Este espacio ha sido diseñado para cargar los archivos de cartera por convenio, relacionados con cada uno de ellos",
        recomendacion: `<b>Para que sea un cargue exitoso le recomendamos:</b><br><br>
                <b>1. Nombre del archivo:</b> debe tener el siguiente formato <b>c_nit_convenio_mesaño</b> <br>
                    -	c indica que el archivo es de cartera <br>
                    -	nit de la entidad <br>
                    -	código: código del convenio o modelo al que pertenece la operación <br>
                    -	mesaño mes del año de dos dígitos seguido del año completo de cuatro dígitos <br>
                <b>2. Formato del archivo:</b> <br>
                    -	El archivo solo podrá tener el formato TXT (texto plano) <br>
                    -	Ejemplo: c_nit_convenio_062012.txt <br>
                <b>3. Formato fecha:</b> <br>
                    -	El formato de las fechas debe ser el siguiente (AAAA-MM-DD)`,
      },
      {
        id: 7,
        titulo: "Registros nuevos",
        nombre_permiso: "cargue_registros",
        visible: false,
        slug: "registros-nuevos",
        texto:
          "Ingreso de las nuevas operaciones de crédito desembolsadas con productos FGA Fondo de Garantías.",
        path: "registros-nuevos",
        intro:
          "Este espacio ha sido diseñado para la carga de archivos nuevos, relacionados con cada convenio",
        recomendacion: `<b>Para que sea un cargue exitoso le recomendamos:</b><br><br>
                <b>1. Nombre del archivo:</b> debe tener el siguiente formato <b>g_nit_convenio_mesaño</b> <br>
                    -	g indica que el archivo es de nuevos registros de operaciones <br>
                    -	nit de la entidad <br>
                    -	código: código del convenio o modelo al que pertenece la operación<br>
                    -	mesaño mes del año de dos dígitos seguido del año completo de cuatro dígitos <br>
                <b>2. Formato del archivo:</b> <br>
                    -	El archivo solo podrá tener el formato TXT (texto plano) <br>
                    -	Ejemplo: g_nit_convenio_062012.txt <br>
                <b>3. Formato fecha:</b> <br>
                    -	El formato de las fechas debe ser el siguiente (AAAA-MM-DD)`,
      },
      {
        id: 8,
        titulo: "Reclamación total",
        nombre_permiso: "cargue_reclamaciones_totales",
        visible: false,
        slug: "reclamaciones-totales",
        texto:
          "Solicitud de pago ante FGA Fondo de Garantías sobre las obligaciones que cumplen con lo definido previamente para este proceso en el contrato.",
        path: "reclamacion-total-garantias",
        intro:
          "Este espacio ha sido diseñado para la carga de archivos de reclamación, relacionados con cada convenio",
        recomendacion: `<b>Para que sea un cargue exitoso le recomendamos:</b><br><br>
                <b>1. Nombre del archivo:</b> debe tener el siguiente formato <b>t_nit_convenio_mesaño</b> <br>
                    -	t indica que el archivo es de reclamación total <br>
                    -	nit de la entidad <br>
                    -	código: código del convenio o modelo al que pertenece la operación <br>
                    -	mesaño mes del año de dos dígitos seguido del año completo de cuatro dígitos <br>
                <b>2. Formato del archivo:</b> <br>
                    -	El archivo solo podrá tener el formato TXT (texto plano) <br>
                    -	Ejemplo: t_nit_convenio_062012.txt <br>
                <b>3. Formato fecha:</b> <br>
                    -	El formato de las fechas debe ser el siguiente (AAAA-MM-DD)<br>
                <b>4. Sugerencia:</b> <br>
                    -	Le sugerimos revisar en el resumen de cifras, el saldo para reclamaciones antes de realizar la carga del archivo. Tenga en cuenta que una reclamación mayor a este valor implicará un proceso posterior de desistimiento a las operaciones de crédito reclamadas.`,
      },
      {
        id: 9,
        titulo: "Reclamación parcial",
        nombre_permiso: "cargue_reclamaciones_parciales",
        visible: false,
        slug: "reclamaciones-parciales",
        texto:
          "Solicitud de pago parcial ante FGA Fondo de Garantías sobre las obligaciones que cumplen con lo definido previamente para este proceso en el contrato.",
        path: "reclamacion-parcial-garantias",
        intro:
          "Este espacio ha sido diseñado para la carga de archivos de reclamación, relacionados con cada convenio",
        recomendacion: `<b>Para que sea un cargue exitoso le recomendamos:</b><br><br>
                <b>1. Nombre del archivo:</b> debe tener el siguiente formato <b>p_nit_convenio_mesaño</b> <br>
                    -	p indica que el archivo es de reclamación parcial <br>
                    -	nit de la entidad <br>
                    -	código: código del convenio o modelo al que pertenece la operación <br>
                    -	mesaño mes del año de dos dígitos seguido del año completo de cuatro dígitos <br>
                <b>2. Formato del archivo:</b> <br>
                    -	El archivo solo podrá tener el formato TXT (texto plano) <br>
                    -	Ejemplo: p_nit_convenio_062012.txt <br>
                <b>3. Formato fecha:</b> <br>
                    -	El formato de las fechas debe ser el siguiente (AAAA-MM-DD)
                <b>4. Sugerencia:</b> <br>
                    -	Le sugerimos revisar en el resumen de cifras, el saldo para reclamaciones antes de realizar la carga del archivo. Tenga en cuenta que una reclamación mayor a este valor implicará un proceso posterior de desistimiento a las operaciones de crédito reclamadas.`,
      },
      {
        id: 91,
        titulo: "Recaudos",
        nombre_permiso: "cargue_recaudos",
        visible: false,
        slug: "recaudos",
        texto: "Recudo de operaciones",
        path: "cargue-recuados",
        intro:
          "Este espacio ha sido diseñado para la carga de archivos de recaudos.",
        recomendacion: `<b>Para que sea un cargue exitoso le recomendamos:</b><br><br>
                <b>1. Nombre del archivo:</b> debe tener el siguiente formato <b>RE_nit_convenio_mesaño</b> <br>
                    -	RE indica que el archivo es de recaudo <br>
                    -	nit de la entidad <br>
                    -	código: código del convenio o modelo al que pertenece la operación <br>
                    -	mesaño mes del año de dos dígitos seguido del año completo de cuatro dígitos <br>
                <b>2. Formato del archivo:</b> <br>
                    -	El archivo solo podrá tener el formato txt (texto plano) <br>
                    -	Ejemplo: RE_nit_convenio_062012.txt <br>`,
      },
      {
        id: 10,
        texto:
          "Anexo del archivo con los documentos de soporte requeridos en el proceso de reclamación de coberturas, según lo definido en el manual operativo.",
        path: "anexo-reclamaciones",
        intro:
          "En este espacio podrás conocer cuáles son los archivos de reclamación pendientes por documento anexo",
        titulo: "Anexo de reclamaciones",
        nombre_permiso: "anexo_reclamaciones",
        visible: false,
        slug: "anexo-de-reclamacion",
        tipo_archivo: ".pdf",
        multiple: true,
        endpoint: "utilidades/cargue_archivos/pagos",
        ruta_guardado: "reclamaciones/anexos",
        recomendacion: `
                <b>Para que sea un cargue exitoso le recomendamos:</b> <br>
                - El nombre del archivo debe tener el mismo número de pagaré que se encuentra en el listado.<br>
                - Formato de archivo PDF: este formato es el estándar internacional actual y ofrece seguridad a la imagen.<br>
                - Resolución de 200x200 dpi: esta resolución permite conservar un tamaño ideal para las imágenes. De no ser legible la información, esta podría ser causal de devolución. Se utiliza un máximo de 300x300 dpi.<br>
                - Modo blanco y negro: si se usa un archivo en escala de grises o a color, el peso será muy alto para cargar al servidor SFTP y al sistema de FGA Fondo de Garantías.<br>
                <br>
                <b>Cada archivo PDF debe contener los siguientes documentos:</b><br>
                - Pagaré con carta de instrucciones<br>
                - Documento que contenga información del cliente<br>
                - Formato de autorización para centrales de riesgos y aceptación de la cobertura<br>
                `,
      },
      {
        id: 11,
        titulo: "Preaprobados",
        nombre_permiso: "cargue_preaprobados",
        visible: false,
        slug: "preaprobados",
        texto:
          "Reporte de las operaciones sujetas a ser garantizadas por FGA Fondo de Garantías, que están asociadas a un convenio marco, como prerrequisito al registro final de la cobertura.",
        path: "preaprobados",
        intro:
          "Este espacio ha sido diseñado para la carga de archivos de preaprobados, relacionados con cada convenio",
        recomendacion: `<b>Para que sea un cargue exitoso le recomendamos:</b><br><br>
                <b>1. Nombre del archivo:</b> debe tener el siguiente formato <b>s_nit_convenio_mesaño</b> <br>
                    -	s indica que el archivo es de preaprobados <br>
                    -	nit de la entidad <br>
                    -	código: código del convenio o modelo al que pertenece la operación <br>
                    -	mesaño mes del año de dos dígitos seguido del año completo de cuatro dígitos <br>
                <b>2. Formato del archivo:</b> <br>
                    -	El archivo solo podrá tener el formato TXT (texto plano) <br>
                    -	Ejemplo: s_nit_convenio_062012.txt <br>
                <b>3. Formato fecha:</b> <br>
                    -	El formato de las fechas debe ser el siguiente (AAAA-MM-DD)`,
      },
      {
        id: 12,
        titulo: "Reestructuraciones",
        nombre_permiso: "cargue_reestructuraciones",
        visible: false,
        slug: "reestructuraciones",
        texto:
          "Registro del cambio de algunas condiciones iniciales de la operación como monto desembolsado o el plazo en la cual se conserva el número de la obligación.",
        path: "reestructuraciones",
        intro:
          "Este espacio ha sido diseñado para la carga de archivos de reestructuraciones, relacionados con cada convenio",
        recomendacion: `<b>Para que sea un cargue exitoso le recomendamos:</b><br><br>
                <b>1. Nombre del archivo:</b> debe tener el siguiente formato <b>a_nit_convenio_mesaño</b> <br>
                    -	a indica que el archivo es de reestructuraciones <br>
                    -	nit de la entidad <br>
                    -	convenio: código del convenio o modelo al que pertenece la operación <br>
                    -	mesaño mes del año de dos dígitos seguido del año completo de cuatro dígitos <br>
                <b>2. Formato del archivo:</b> <br>
                    -	El archivo solo podrá tener el formato TXT (texto plano) <br>
                    -	Ejemplo: a_nit_convenio_062012.txt <br>
                <b>3. Formato fecha:</b> <br>
                    -	El formato de las fechas debe ser el siguiente (AAAA-MM-DD)`,
      },
      {
        id: 13,
        titulo: "Novaciones",
        nombre_permiso: "cargue_novaciones_saldo",
        visible: false,
        slug: "novaciones-saldo",
        texto:
          "Registro el proceso de novación de una operación previamente registrada y reportada a FGA Fondo de Garantías.",
        path: "novaciones",
        intro:
          "Este espacio ha sido diseñado para la carga de archivos de novaciones, relacionados con cada convenio",
        recomendacion: `<b>Para que sea un cargue exitoso le recomendamos:</b><br><br>
                <b>1. Nombre del archivo:</b> debe tener el siguiente formato <b>v_nit_convenio_mesaño</b> <br>
                    -	v indica que el archivo es de novaciones <br>
                    -	nit de la entidad <br>
                    -	códigos: código del convenio o modelo al que pertenece la operación <br>
                    -	mesaño mes del año de dos dígitos seguido del año completo de cuatro dígitos <br>
                <b>2. Formato del archivo:</b> <br>
                    -	El archivo solo podrá tener el formato TXT (texto plano) <br>
                    -	Ejemplo: v_nit_convenio_062012.txt <br>
                <b>3. Formato fecha:</b> <br>
                    -	El formato de las fechas debe ser el siguiente (AAAA-MM-DD)`,
      },
      {
        id: 9999,
        titulo: "Reclamación Operaciones sin cobertura",
        nombre_permiso: "cargue_no_garantizados",
        visible: false,
        slug: "operaciones-no-garantizados",
        texto:
          "Solicitud de pago ante FGA Fondo de Garantías sobre las operaciones que no fueron objeto de cobro de cobertura y que cumplen con lo definido previamente para este proceso en el contrato.",
        path: "no-garantizados",
        intro:
          "Este espacio ha sido diseñado para la carga de archivos de operaciones sin cobro cobertura, relacionados con cada convenio",
        recomendacion: `<b>Para que sea un cargue exitoso le recomendamos:</b><br><br>
                <b>1. Nombre del archivo:</b> debe tener el siguiente formato <b>z_nit_convenio_mesaño</b> <br>
                    -	z indica que el archivo es de operaciones sin cobro cobertura <br>
                    -	nit de la entidad <br>
                    -	código: código del convenio o modelo al que pertenece la operación <br>
                    -	mesaño mes del año de dos dígitos seguido del año completo de cuatro dígitos <br>
                <b>2. Formato del archivo:</b> <br>
                    -	El archivo solo podrá tener el formato TXT (texto plano) <br>
                    -	Ejemplo: z_nit_convenio_062012.txt <br>
                <b>3. Formato fecha:</b> <br>
                    -	El formato de las fechas debe ser el siguiente (AAAA-MM-DD)`,
      },
      {
        id: 15,
        titulo: "Aumento de cupo",
        nombre_permiso: "cargue_aumento_cupo",
        visible: false,
        slug: "aumento-cupo",
        texto:
          "Solicitud de aumento de cupo ante FGA Fondo de Garantías sobre las garantías que cumplen con lo definido previamente para este proceso en el contrato.",
        path: "aumento-cupo",
        intro:
          "Este espacio ha sido diseñado para la carga de archivos de aumento de cupo, relacionados con cada convenio",
        recomendacion: `<b>Para que sea un cargue exitoso le recomendamos:</b><br><br>
                <b>1. Nombre del archivo:</b> debe tener el siguiente formato <b>o_nit_convenio_mesaño</b> <br>
                    -	o indica que el archivo es de aumento de cupo <br>
                    -	nit de la entidad <br>
                    -	código: código del convenio o modelo al que pertenece la operación <br>
                    -	mesaño mes del año de dos dígitos seguido del año completo de cuatro dígitos <br>
                <b>2. Formato del archivo:</b> <br>
                    -	El archivo solo podrá tener el formato TXT (texto plano) <br>
                    -	Ejemplo: o_nit_convenio_062012.txt <br>
                <b>3. Formato fecha:</b> <br>
                    -	El formato de las fechas debe ser el siguiente (AAAA-MM-DD)`,
      },
      {
        id: 16,
        texto:
          "Solicitud de venta de cartera ante FGA Fondo de Garantías sobre las garantías que cumplen con lo definido previamente para este proceso en el contrato.",
        path: "venta-cartera",
        titulo: "Venta de cartera",
        nombre_permiso: "cargue_venta_cartera",
        visible: false,
        slug: "venta-de-cartera",
        tipo_archivo: ".txt",
        multiple: false,
        recomendacion: `<b>Para que sea un cargue exitoso le recomendamos:</b><br><br>
                <b>1. Nombre del archivo:</b> debe tener el siguiente formato <b>vc_nit_convenio_mesaño</b> <br>
                    -	vc indica que el archivo es de venta de cartera <br>
                    -	nit de la entidad <br>
                    -	código: código del convenio o modelo al que pertenece la operación <br>
                    -	mesaño mes del año de dos dígitos seguido del año completo de cuatro dígitos <br>
                <b>2. Formato del archivo:</b> <br>
                    -	El archivo solo podrá tener el formato TXT (texto plano) <br>
                    -	Ejemplo: vc_nit_convenio_062012.txt <br>
                <b>3. Formato fecha:</b> <br>
                    -	El formato de las fechas debe ser el siguiente (AAAA-MM-DD)`,
      },
      {
        id: 17,
        titulo: "Reclamación por excepción",
        nombre_permiso: "cargue_reclamacion_excepcion",
        visible: false,
        slug: "reclamaciones-excepcion",
        texto:
          "Solicitud de pago ante FGA Fondo de Garantías sobre las obligaciones garantizadas que no cumplen con lo definido previamente para este proceso en el contrato.",
        path: "reclamacion-excepcion-garantias",
        intro:
          "Este espacio ha sido diseñado para la carga de archivos de reclamación, relacionados con cada convenio",
        recomendacion: `<b>Para que sea un cargue exitoso le recomendamos:</b><br><br>
                <b>1. Nombre del archivo:</b> debe tener el siguiente formato <b>x_nit_convenio_mesaño</b> <br>
                    -	x indica que el archivo es de reclamación total <br>
                    -	nit de la entidad <br>
                    -	código: código del convenio o modelo al que pertenece la operación <br>
                    -	mesaño mes del año de dos dígitos seguido del año completo de cuatro dígitos <br>
                <b>2. Formato del archivo:</b> <br>
                    -	El archivo solo podrá tener el formato TXT (texto plano) <br>
                    -	Ejemplo: x_nit_convenio_062012.txt <br>
                <b>3. Formato fecha:</b> <br>
                    -	El formato de las fechas debe ser el siguiente (AAAA-MM-DD)<br>
                <b>4. Sugerencia:</b> <br>
                    -	Le sugerimos revisar en el resumen de cifras, el saldo para reclamaciones antes de realizar la carga del archivo. Tenga en cuenta que una reclamación mayor a este valor implicará un proceso posterior de desistimiento a las operaciones de crédito reclamadas.`,
      },
      {
        id: 18,
        titulo: "Recaudos",
        nombre_permiso: "cargue_recaudos",
        visible: false,
        slug: "recaudos",
        texto: "Recudo de operaciones",
        path: "cargue-recuados",
        intro:
          "Este espacio ha sido diseñado para la carga de archivos de recaudos.",
        recomendacion: `<b>Para que sea un cargue exitoso le recomendamos:</b><br><br>
                <b>1. Nombre del archivo:</b> debe tener el siguiente formato <b>RE_nit_convenio_mesaño</b> <br>
                    - RE indica que el archivo es de recaudo <br>
                    - nit de la entidad <br>
                    - código: código del convenio o modelo al que pertenece la operación <br>
                    - mesaño mes del año de dos dígitos seguido del año completo de cuatro dígitos <br>
                <b>2. Formato del archivo:</b> <br>
                    - El archivo solo podrá tener el formato txt (texto plano) <br>
                    - Ejemplo: RE_nit_convenio_062012.txt <br>`,
      },
      {
        id: 173,
        texto:
          "Requerimientos para el proceso de reclamación de coberturas, según lo definido en el manual operativo.",
        path: "requerimientos-reclamacion",
        intro:
          "En este espacio podrás conocer cuáles son los archivos de reclamación pendientes por documento anexo",
        titulo: "Requerimientos reclamación",
        nombre_permiso: "requerimientos_reclamacion",
        visible: false,
        slug: "requerimientos-reclamacion",
        tipo_archivo: ".pdf",
        multiple: true,
        endpoint: "utilidades/cargue_archivos/pagos",
        ruta_guardado: "reclamaciones/anexos",
        recomendacion: `
                <b>Para que sea un cargue exitoso le recomendamos:</b> <br>
                - El nombre del archivo debe tener el mismo número de pagaré que se encuentra en el listado.<br>
                - Formato de archivo PDF: este formato es el estándar internacional actual y ofrece seguridad a la imagen.<br>
                - Resolución de 200x200 dpi: esta resolución permite conservar un tamaño ideal para las imágenes. De no ser legible la información, esta podría ser causal de devolución. Se utiliza un máximo de 300x300 dpi.<br>
                - Modo blanco y negro: si se usa un archivo en escala de grises o a color, el peso será muy alto para cargar al servidor SFTP y al sistema de FGA Fondo de Garantías.<br>
                <br>
                <b>Cada archivo PDF debe contener los siguientes documentos:</b><br>
                - Pagaré con carta de instrucciones<br>
                - Documento que contenga información del cliente<br>
                - Formato de autorización para centrales de riesgos y aceptación de la cobertura<br>
                `,
      },
    ],
    DocumentosParaDescarga: [],
    tablaEstadoProceso: {
      datos: [],
      paginacion: {
        total: 0,
      },
    },
    tablaGarantizado: {
      datos: [],
      paginacion: {
        total: 0,
      },
    },
    tablaAbono: {
      datos: [],
      paginacion: {
        total: 0,
      },
    },
    SelectFiltroTabla: [
      {
        value: null,
        text: "Seleccione un proceso",
      },
      {
        value: "Cargue de cartera rotativa",
        text: "Cargue de cartera rotativa",
      },
      {
        value: "proceso2",
        text: "Proceso 2",
      },
      {
        value: "proceso3",
        text: "Proceso 3",
      },
      {
        value: "proceso4",
        text: "Proceso 4",
      },
    ],

    TablaProductos: [
      {
        codigo: "1",
        fecha_inicial: "2016-06-01",
        fecha_final: "2020-05-31",
        cupo_global: "40.000.000.000",
        base_siniestralidad: "I",
        estado: "Registros pagos y recuparaciones",
        ver_productos: "Ver",
      },
      {
        codigo: "2",
        fecha_inicial: "2016-06-01",
        fecha_final: "2020-05-31",
        cupo_global: "40.000.000.000",
        base_siniestralidad: "I",
        estado: "Registros pagos y recuparaciones",
        ver_productos: "Ver",
      },
      {
        codigo: "3",
        fecha_inicial: "2016-06-01",
        fecha_final: "2020-05-31",
        cupo_global: "40.000.000.000",
        base_siniestralidad: "I",
        estado: "Registros pagos y recuparaciones",
        ver_productos: "Ver",
      },
    ],
    TablaVerProducto: [
      {
        codigo_del_producto: "1",
        nombre_del_producto: "Credito ordinario consumo Bancolombia",
        rango_inicial: "1 mes(es)",
        rango_final: "120 meses",
        base_del_valor_del_servicio_de_fianza: "7%",
        tipo_del_valor_del_servicio_de_fianza: "BASE",
        modalidad_del_valor_del_servicio_de_fianza: "Única Anticipada",
        porcentaje_de_siniestralidad: "90 %",
        plazo_promedio: "0 meses",
      },
      {
        codigo_del_producto: "2",
        nombre_del_producto: "Credito consumo rotativo Bancolombia",
        rango_inicial: "1 mes(es)",
        rango_final: "120 meses",
        base_del_valor_del_servicio_de_fianza: "7%",
        tipo_del_valor_del_servicio_de_fianza: "BASE",
        modalidad_del_valor_del_servicio_de_fianza: "Única Anticipada",
        porcentaje_de_siniestralidad: "90 %",
        plazo_promedio: "0 meses",
      },
      {
        codigo_del_producto: "1",
        nombre_del_producto: "Credito motos corbeta Bancolombia",
        rango_inicial: "1 mes(es)",
        rango_final: "120 meses",
        base_del_valor_del_servicio_de_fianza: "7%",
        tipo_del_valor_del_servicio_de_fianza: "BASE",
        modalidad_del_valor_del_servicio_de_fianza: "Única Anticipada",
        porcentaje_de_siniestralidad: "90 %",
        plazo_promedio: "0 meses",
      },
      {
        codigo_del_producto: "1",
        nombre_del_producto: "Credito ordinario consumo Bancolombia",
        rango_inicial: "1 mes(es)",
        rango_final: "120 meses",
        base_del_valor_del_servicio_de_fianza: "7%",
        tipo_del_valor_del_servicio_de_fianza: "BASE",
        modalidad_del_valor_del_servicio_de_fianza: "Única Anticipada",
        porcentaje_de_siniestralidad: "90 %",
        plazo_promedio: "0 meses",
      },
      {
        codigo_del_producto: "2",
        nombre_del_producto: "Credito consumo rotativo Bancolombia",
        rango_inicial: "1 mes(es)",
        rango_final: "120 meses",
        base_del_valor_del_servicio_de_fianza: "7%",
        tipo_del_valor_del_servicio_de_fianza: "BASE",
        modalidad_del_valor_del_servicio_de_fianza: "Única Anticipada",
        porcentaje_de_siniestralidad: "90 %",
        plazo_promedio: "0 meses",
      },
      {
        codigo_del_producto: "1",
        nombre_del_producto: "Credito motos corbeta Bancolombia",
        rango_inicial: "1 mes(es)",
        rango_final: "120 meses",
        base_del_valor_del_servicio_de_fianza: "7%",
        tipo_del_valor_del_servicio_de_fianza: "BASE",
        modalidad_del_valor_del_servicio_de_fianza: "Única Anticipada",
        porcentaje_de_siniestralidad: "90 %",
        plazo_promedio: "0 meses",
      },
    ],
    misMensajes: [
      {
        titulo:
          "Tips para que tus operaciones en el Portal Transaccional FGA sean más eficientes.",
        mensaje:
          '<p>Recuerda revisar el resultado de los cargues, en la sección "Estado de procesos"; allí podrás verificar el número de registros cargados y el número de errores o advertencias que se generan. No olvides que radicar una novedad a tiempo puede evitarte reprocesos y así agilizar la posible reclamación de una operación.</p><p>Si tienes alguna novedad, inconsistencia o inquietud respecto al Portal Transaccional o la operación, debes radicarlas a través de la opción "Novedaes" o "Servicio al cliente".</p><p>Para una mayor efectividad del proceso, te recomendamos realizar los cargues de la siguiente manera:</p><p></p><ul class="lista_numero"><li>Nuevos registros</li><li>Registros de novaciones</li><li>Cartera.</li></ul><p></p><p>No olvides que los cargues los debes realizar dentro de los primeros diez (10) días de cada mes. </p><p>Para tener una mayor agilidad en el pago de operaciones, es muy importante que radiques las reclamaciones dentro de los primeros cinco (5) días del mes.</p>',
      },
    ],
  },
  getters: {
    reload: (state) => state.reload,
    dataInformes: (state) => state.dataInformes,
    convenios: (state) => state.convenios,
    productos: (state) => state.productos,
    dataSlider: (state) => state.dataSlider,
    EstructurasTecnicas: (state) => state.EstructurasTecnicas,
    FormatosNoveades: (state) => state.FormatosNoveades,
    Informes: (state) => state.Informes,
    CargaArchivos: (state) => state.CargaArchivos,
    DocumentosParaDescarga: (state) => state.DocumentosParaDescarga,
    tablaEstadoProceso: (state) => state.tablaEstadoProceso,
    tablaGarantizado: (state) => state.tablaGarantizado,
    tablaAbono: (state) => state.tablaAbono,
    SelectFiltroTabla: (state) => state.SelectFiltroTabla,
    TablaProductos: (state) => state.TablaProductos,
    TablaVerProducto: (state) => state.TablaVerProducto,
    misMensajes: (state) => state.misMensajes,
    FormatosRegistros: (state) => state.FormatosRegistros,
    Manuales: (state) => state.Manuales,
    OtrosFormatos: (state) => state.OtrosFormatos,
    respuestaAnexosCargues: (state) => state.respuestaAnexosCargues,
    utilidadesDescargas: (state) => state.utilidadesDescargas,
    total: (state) => state.dataInformes.paginacion.total,
  },
  mutations: {
    //SET_INFORMES: (state, payload) => state.Informes[payload.id].data = payload.data
    SET_RELOAD: (state, payload) => (state.reload = payload),
    SET_INFORMES: (state, payload) => (state.dataInformes = payload),
    SET_TOTAL: (state, payload) =>
      (state.dataInformes.paginacion.total = payload),
    SET_CONVENIOS: (state, payload) => (state.convenios = payload),
    SET_PRODUCTOS: (state, payload) => (state.productos = payload),
    SET_BANNER: (state, payload) => (state.dataSlider = payload),
    SET_ESTADO_PROCESO: (state, payload) =>
      (state.tablaEstadoProceso = payload),
    SET_GARANTIZADO: (state, payload) =>
      (state.tablaGarantizado = {
        paginacion: { total: payload.total },
        datos: payload.datos,
      }),
    SET_ABONOS: (state, payload) => (state.tablaAbono = payload),
    [SOCKET_PROCESO]: (state, payload) => {
      const index = state.tablaEstadoProceso.datos.findIndex(
        (item) => item.id === payload.id
      );
      if (index !== -1) {
        state.tablaEstadoProceso.datos.splice(index, 1, payload);
      } else {
        let datos = [payload].concat(state.tablaGarantizado.datos);
        state.tablaEstadoProceso.datos = datos;
      }
    },
    [SOCKET_GARANTIZADOS]: (state, payload) => {
      const index = state.tablaGarantizado.datos.findIndex(
        (item) => item.id === payload.id
      );

      console.log(payload);

      let datos = state.tablaGarantizado.datos;
      state.tablaGarantizado.datos = [];

      if (index !== -1) {
        datos.splice(index, 1, payload);
      } else {
        datos = [payload].concat(datos);
      }
      state.tablaGarantizado.datos = datos;
    },
    SET_UTILIDADES_DESCARGAS: (state, payload) => {
      state.utilidadesDescargas = payload;
    },

    //SOCKET_CARGUE_ANEXO_RECLAMACION: (state, payload) => //state.respuestaAnexosCargues.push(payload)
    SET_PERMISOS_CARGUE: (state, payload) => {
      payload.children.forEach((permiso) => {
        if (typeof permiso.permisos != "object") {
          permiso.permisos = JSON.parse(permiso.permisos);
        }
        const index = state.CargaArchivos.findIndex(
          (cargue) => cargue.nombre_permiso == permiso.descripcion
        );
        if (index !== -1) {
          state.CargaArchivos[index]["visible"] = permiso.permisos.Crear;
        }
      });
    },
    SET_PERMISOS_INFORME: (state, payload) => {
      if (payload.children) {
        payload.children.forEach((permiso) => {
          if (typeof permiso.permisos != "object") {
            permiso.permisos = JSON.parse(permiso.permisos);
          }
          const index = state.Informes.findIndex(
            (informe) => informe.nombre_permiso === permiso.descripcion
          );
          if (index !== -1) {
            state.Informes[index]["visible"] = permiso.permisos.Ver;
          }
        });
      }
    },
    SET_PERMISOS_DOCUMENTOS: (state, payload) => {
      if (payload.children) {
        payload.children.forEach((permiso) => {
          state.DocumentosParaDescarga.push({
            id: permiso.id,
            mimeType: permiso.mimeType,
            extension: permiso.extension,
            descripcion: permiso.descripcion,
            titulo: permiso.titulo,
            hijos: permiso.children,
          });
        });
      }
    },
  },
  actions: {
    fetch({ commit, state }, payload) {
      this.dispatch("index", payload).then((response) => {
        this.dispatch("pages/refresh", response);
      });
    },
    refresh({ commit }, payload) {
      commit("SET_INFORMES", payload);
      commit("SET_TOTAL", payload.paginacion.total);
    },
    fetchConvenios({ commit }, payload) {
      this.dispatch("index", payload).then((response) => {
        commit("SET_CONVENIOS", response.datos);
      });
    },
    fetchProductos({ commit }, payload) {
      this.dispatch("helper", payload).then((response) => {
        commit("SET_PRODUCTOS", response.datos);
      });
    },
    fetchEstadoProceso({ commit }, payload) {
      this.dispatch("index", payload).then((response) => {
        commit("SET_ESTADO_PROCESO", response);
      });
    },
    fetchGarantizado({ commit }, payload) {
      this.dispatch("index", payload).then((response) => {
        commit("SET_GARANTIZADO", response);
      });
    },
    fetchAbonos({ commit }, payload) {
      this.dispatch("index", payload).then((response) => {
        commit("SET_ABONOS", response);
      });
    },
    fetchBanner({ commit }, payload) {
      this.dispatch("index", payload).then((response) => {
        commit("SET_BANNER", response.datos);
      });
    },
    fetchEncuesta({}) {
      return new Promise((resolve, reject) => {
        this.state.api
          .get('/portal/encuesta')
          .then(response => {
            localStorage.setItem('surveyPopup', JSON.stringify(response.data.data));
            response.data.data.forEach(survey => {
              localStorage.setItem('completedSurveys_'+ survey.id, false);
            });
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    fetchUtilidadesDescargas({ commit }, payload) {
      this.dispatch("index", payload).then((response) => {
        commit("SET_UTILIDADES_DESCARGAS", response.datos);
      });
    },
    setPermisosCargue({ commit }, payload) {
      payload ? commit("SET_PERMISOS_CARGUE", payload) : "";
    },
    setPermisosInforme({ commit }, payload) {
      payload ? commit("SET_PERMISOS_INFORME", payload) : "";
    },
    setPermisosDocumentos({ commit }, payload) {
      payload ? commit("SET_PERMISOS_DOCUMENTOS", payload) : "";
    },
    getUser({ rootState, commit }, payload) {},
  },
};
